import ShopSection from "../components/homeComponents/ShopSection";
import CategorySection from "../components/homeComponents/CategorySection";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import BestDealSection from "../components/homeComponents/BestDealSection";
import CustomThumbSection from "../components/homeComponents/CustomThumbSection";
import { HOME_PAGE_DEFAULT_GROUP_OBJECT_ID } from "../config/Constant";
import SearchSection from "../components/CommonComponents/SearchSection";
import HeroSectionTech from "../components/HeroSectionTech/hero-section-tech";
import CarouselBanner from "../shared/components/Banner/CarouselBanner";

const GroceryHomeScreen = ({ match, filters = {} }) => {
  console.log("Grocery FIlter: ", filters);
  // const [showModal, setShowModal] = useState(false);

  // AUTO OPEN MODAL ON PAGE LOAD
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowModal(true);
  //   }, 300); // small delay for smoother UX

  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <div className="container">
      {/* SHOW COUPON BUTTON */}
      {/* <div className="text-center my-4">
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>
          Show Coupon
        </button>
      </div> */}

      {/* BOOTSTRAP MODAL */}
      {/* <CouponModal show={showModal} onClose={() => setShowModal(false)} /> */}

      {/* BACKDROP FIX */}
      {/* {showModal && (
        <div
          className="modal-backdrop fade show"
          onClick={() => setShowModal(false)}
        ></div>
      )} */}

      {/* PAGE CONTENT */}
      <CarouselBanner />
      {filters?.keyword && (
        <SearchSection
          keyword={filters.keyword}
          pageNumber={filters.pageNumber}
          pageSize={filters.pageSize}
          brand={filters.brand}
          sort={filters.sort}
          price={filters.price}
          searchId={filters.searchId}
        />
      )}

      <BestDealSection />
      <CategorySection />
      <CustomThumbSection groupId={HOME_PAGE_DEFAULT_GROUP_OBJECT_ID} />
      <HeroSectionTech />

      <ShopSection
        keyword={""}
        pageNumber={filters.pageNumber}
        pageSize={filters.pageSize}
        brand={filters.brand}
        sort={filters.sort}
        price={filters.price}
      />
    </div>
  );
};

export default GroceryHomeScreen;
